package com.anjuros.website.templates.template5.modules

import com.anjuros.website.templates.template5.util.ResKey


enum class Template5Achievement(
    val value: String,
    val text: ResKey
) {
    Template5Achievement1(
        value = "2016",
        text = ResKey.TEMPLATE5_ACHIEVEMENT1
    ),

    Template5Achievement2(
        value = "500+",
        text = ResKey.TEMPLATE5_ACHIEVEMENT2
    ),

    Template5Achievement3(
        value = "100%",
        text = ResKey.TEMPLATE5_ACHIEVEMENT3
    )
}
